module.exports = __webpack_public_path__ + "static/media/banff-32.d3d4dc68.jpg";